let openCount = 0;

export function trackFullscreenModal(open: boolean) {
  openCount = Math.max(0, openCount + (open ? 1 : -1));
}

/** Page-level Esc handlers must yield while a modal owns the key. */
export function isFullscreenModalOpen() {
  return openCount > 0;
}
